import { localKeys } from '@m2h/common/constants';
import { safeParse } from '@m2h/common/utils/common';
import pureReq from '../request/pureReq';

const APIS = {
  abStrategy: '/api/sailor/v6/ab/exp/strategy',
};

// 请求头中使用的的strategy字段
interface VStrategyComKey {
  sceneKey?: string; // A/B策略查询条件-场景名
  groupKey?: string; // A/B策略查询条件-分组名
  expKey?: string; // 具体的A/B策略的值
  param?: {
    commonParam?: number; //commonParam=1代表，这个实验数据需要传入业务接口的通参去
  };
}
// 接口返回的字段
interface VStrategyAllKey extends VStrategyComKey {
  modelName?: string; //模块名：暂无用
  groupName?: string; //分组名，暂无用
  configName?: string; //暂无用
  configInfo?: string; //暂无用
}
// 桥获取入参参数
interface VStrategyGet {
  sceneKey?: string;
  groupKey?: string;
}

interface VStrategyCache {
  isCached: boolean;
  strategies: VStrategyAllKey[];
  rawValue: string | null;
}

let pendingAbStrategyRequest: Promise<VStrategyAllKey[]> | null = null;

const readStrategyCache = (key: string): VStrategyCache => {
  const rawValue = localStorage.getItem(key);
  const parsedValue = safeParse(rawValue, null);
  return {
    isCached: rawValue !== null && Array.isArray(parsedValue),
    strategies: Array.isArray(parsedValue) ? parsedValue : [],
    rawValue,
  };
};

// 单页应用切路由不会执行到
export function fetchAbStrategy(): Promise<VStrategyAllKey[]> {
  if (!pendingAbStrategyRequest) {
    pendingAbStrategyRequest = (async () => {
      try {
        const params = {
          sceneType: 'FRONT_SAILOR_C',
        };
        const res = await pureReq({
          url: APIS.abStrategy,
          method: 'POST',
          data: params,
          dataType: 'json',
        });
        const { code, data } = res?.data || {};
        let allStrategys: VStrategyAllKey[] = [];
        const commonStrategys: VStrategyComKey[] = [];
        if (code === 0) {
          allStrategys = data?.map((s) => {
            const comtrategy = {
              expKey: s.exp_name, // 具体的A/B策略的值
              groupKey: s.exp_group_key, // A/B策略查询条件-分组名
              sceneKey: s.scene_name, // A/B策略查询条件-场景名
              param: {
                ...s.params_info, //commonParam=1代表，这个实验数据需要传入业务接口的通参去
              },
            };
            const allStrategy = {
              modelName: s.model_name, //模块名：暂无用
              groupName: s.exp_group_name, //分组名，暂无用
              configName: s.exp_config_name, //暂无用
              configInfo: s.exp_config_info, //暂无用
              ...comtrategy,
            };
            if (allStrategy.param?.commonParam === '1') {
              commonStrategys.push(comtrategy);
            }
            return allStrategy;
          }) || [];
          localStorage.setItem(localKeys.LOCAL_MACH_STRATEGY, JSON.stringify(allStrategys));
          localStorage.setItem(localKeys.LOCAL_MACH_STRATEGY_COM, JSON.stringify(commonStrategys));
        }
        // console.log('getAbStrategy', allStrategys);
        return allStrategys;
      } catch (e) {
        console.log('getAbStrategy err', e);
        return [];
      }
    })().finally(() => {
      pendingAbStrategyRequest = null;
    });
  }

  return pendingAbStrategyRequest;
}

export const hasCachedAbStrategy = (): boolean => {
  return readStrategyCache(localKeys.LOCAL_MACH_STRATEGY).isCached;
};

// 从存储中获取单个Strategy。 可能为空，会先返回空数组
export const getStrategy = ({ sceneKey, groupKey }: VStrategyGet = {}): VStrategyAllKey => {
  const {
    isCached,
    strategies: storedStrategys,
  } = readStrategyCache(localKeys.LOCAL_MACH_STRATEGY);

  if (!isCached) {
    fetchAbStrategy();
    return {};
  }

  if (sceneKey && groupKey) {
    return storedStrategys.find((s) => (s.sceneKey === sceneKey && s.groupKey === groupKey)) || {};
  }
  // fetchAbStrategy();
  // console.log('getStrategy', sceneKey, groupKey);
  return {};
};

// 从存储中获取Strategy。 可能为空，会先返回空数组
export const getComStrategys = (asJson = false): VStrategyAllKey[] | string => {
  const {
    isCached,
    strategies: storedStrategys,
    rawValue: comStrategysJson,
  } = readStrategyCache(localKeys.LOCAL_MACH_STRATEGY_COM);

  if (!isCached) {
    fetchAbStrategy();
    return asJson ? '[]' : [];
  }

  // console.log('getStrategy', storedStrategys);
  return asJson ? (comStrategysJson || '[]') : storedStrategys;
};
